import { InputSelectOption } from "@sharedComponents/InputSelect/types";
import { ArticleSupplierType } from "@apps/Shared/Services/CompanyInformations/interfaces";

export type ProducerFormProps = {
    myPagesRoute: string
    helpText?: any
    cmsContent?: any
    termsAndConditions?: any
    termsAndConditionsButtons?: Array<any>
    alternativeTermsAndConditions?: any
    onCancel: Function
    formType?: string | undefined
}

export enum NumberType {
    OrganisationNumber = 'org',
    VATNumber = 'vat',
}

export type Step1ValueModel = {
    organizationNumber?: string;
    vatNumber?: string;
    numberType?: string;
    optionalConnection: boolean;
}

export type Step2ValueModel = {
    organizationNumber?: string;
    vatNumber?: string;
    numberType?: string;
    companyName?: string;
    registeredForFTax: string;
    registeredForVAT: string;
    streetAddress?: string;
    zipCode?: string;
    city?: string;
    country?: InputSelectOption;
    email?: string;
    selectedSupplierType: ArticleSupplierType[];
}

export type Step3ValueModel = {
    metalPackaging?: string;
    plasticPackagingSmall?: string;
    plasticPackagingLarge?: string;
}

export type Step4ValueModel = {
    contactInfo?: ContactInformation;
    oneContact?: boolean;
}

export type Step5ValueModel = {
    terms: boolean;
    termsText?: string;
}

export type ContactInformation = {
    [key: string]: any;
    combined?: ContactProps;
    agreement?: ContactProps;
    signatory?: ContactProps;
    productManager?: ContactProps;
    salesReporting?: ContactProps;
}

export type ContactProps = {
    firstname?: string;
    lastname?: string;
    email?: string;
    mobileNumber?: string;
    phoneNumber?: string;
}